import PropTypes from "prop-types";
import { ErrorBoundary } from "react-error-boundary";
import FallbackErrorPage from "Components/fallback_error";
import Head from "next/head";
import { appWithTranslation } from "next-i18next";
import { wrapper } from "../store";

function App({ Component, pageProps, err }) {

	return (
		<ErrorBoundary
			FallbackComponent={FallbackErrorPage}
		>
			<Head>
				<meta charSet="utf-8" />
				<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
				<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
			</Head>
			<Component {...pageProps} err={err} />
		</ErrorBoundary>
	);

}

App.propTypes = {
	Component: PropTypes.func.isRequired,
	pageProps: PropTypes.shape({ root: PropTypes.string }).isRequired,
	err: PropTypes.shape({ root: PropTypes.string }),
};

App.defaultProps = {
	err: {},
};

// export default App
export default appWithTranslation(wrapper.withRedux(App));
